import { UpdateInventoryTypeFieldMessage } from '@/@types/messages/UpdateInventoryTypeFieldMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class InventoryTypeFieldService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public deleteInventoryTypeField(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/inventory-type-fields/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateInventoryTypeField(inventoryTypeFieldId: number, updateInventoryTypeFieldMessage: UpdateInventoryTypeFieldMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateInventoryTypeFieldMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/inventory-type-fields/${inventoryTypeFieldId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
